// GOLDEN PEARL OFFICIAL SHOPIFY THEME JAVASCRIPT
document.addEventListener('DOMContentLoaded', () => {
  function isDesignMode() {
    return Boolean(
      (window.Shopify && window.Shopify.designMode) ||
      (window.GPTheme && window.GPTheme.isDesignMode)
    );
  }

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatMoneyPKR(cents) {
    const num = Number(cents);
    const rupees = Math.round((isNaN(num) ? 0 : num) / 100);
    return 'Rs. ' + (isNaN(rupees) ? 0 : rupees).toLocaleString();
  }

  function cleanVariantTitle(str) {
    if (!str) return '';
    let s = String(str).trim();
    if (s.toLowerCase() === 'default title' || s.toLowerCase() === 'default') return '';
    return s.trim();
  }

  function getShopifyRoute(endpoint) {
    const cleanEndpoint = endpoint.replace(/^\//, '');
    const isAjax = cleanEndpoint.endsWith('.js');
    if (window.routes) {
      let base = '';
      if (cleanEndpoint.startsWith('cart/change') && window.routes.cart_change_url) base = window.routes.cart_change_url;
      else if (cleanEndpoint.startsWith('cart/update') && window.routes.cart_update_url) base = window.routes.cart_update_url;
      else if (cleanEndpoint.startsWith('cart/add') && window.routes.cart_add_url) base = window.routes.cart_add_url;
      else if (cleanEndpoint.startsWith('cart/clear') && window.routes.cart_clear_url) base = window.routes.cart_clear_url;
      else if (cleanEndpoint.startsWith('cart') && window.routes.cart_url) base = window.routes.cart_url;

      if (base) {
        if (isAjax) {
          return base.endsWith('.js') ? base : (base.replace(/\/$/, '') + '.js');
        }
        return base;
      }
    }
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return (root.endsWith('/') ? root : (root + '/')) + cleanEndpoint;
  }

  // 1. Native Shopify Sort Dropdown Change Handler
  const sortSelect = document.querySelector('.gp-sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', (e) => {
      if (isDesignMode()) {
        e.preventDefault();
        return;
      }
      const value = e.target.value;
      const url = new URL(window.location.href);
      if (value && value !== 'manual') {
        url.searchParams.set('sort_by', value);
      } else {
        url.searchParams.delete('sort_by');
      }
      window.location.href = url.toString();
    });
  }

  // 2. Collection Filter Panel Toggle
  const filterBtns = document.querySelectorAll('.gp-filter-btn');
  const filterPanel = document.getElementById('gp-collection-filter-panel') || document.querySelector('.gp-facets-filter-panel');
  filterBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const isActive = filterPanel?.classList.toggle('active');
      btn.classList.toggle('active', isActive);
      btn.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });
  });

  // 3. Cart Drawer open/close & AJAX Cart Management
  const cartDrawer = document.getElementById('gp-cart-drawer');
  const drawerItemsContainer = document.getElementById('gp-drawer-items');
  const noteContainer = document.getElementById('gp-order-note-container');
  const noteInput = document.getElementById('gp-cart-note-input');
  let isCartBusy = false;
  let cartBusyTimer = null;

  function setCartBusy(busy) {
    isCartBusy = !!busy;
    if (cartBusyTimer) {
      clearTimeout(cartBusyTimer);
      cartBusyTimer = null;
    }
    if (busy) {
      cartBusyTimer = setTimeout(() => {
        isCartBusy = false;
      }, 4000);
    }
  }

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('active');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('gp-drawer-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('active');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('gp-drawer-open');
    document.body.style.overflow = '';
  }

  function updateFreeShippingDisplay(rawTotalPrice, hasItems) {
    const freeShippingBarEl = document.querySelector('.gp-free-shipping-bar');
    const freeShippingTextEl = document.getElementById('free-shipping-text') || document.querySelector('.gp-free-shipping-bar p');
    const freeShippingFillEl = document.querySelector('.gp-progress-fill');
    if (!freeShippingTextEl || !freeShippingFillEl) return;

    // Get threshold (default 3500 PKR)
    let thresholdRupees = (window.GPTheme && window.GPTheme.freeShippingThreshold) || 3500;
    if (freeShippingBarEl) {
      const attr = freeShippingBarEl.getAttribute('data-threshold');
      if (attr) {
        const parsed = parseInt(attr, 10);
        if (!isNaN(parsed) && parsed > 0) thresholdRupees = parsed;
      }
    }

    const num = Number(rawTotalPrice) || 0;
    // In Shopify cart.total_price is in cents (e.g., 320000 = Rs. 3,200)
    const currentRupees = Math.round(num / 100);

    if (!hasItems || currentRupees <= 0) {
      freeShippingTextEl.innerHTML = 'Add Rs. ' + thresholdRupees.toLocaleString() + ' more for free shipping!';
      freeShippingFillEl.style.width = '0%';
    } else if (currentRupees >= thresholdRupees) {
      freeShippingTextEl.innerHTML = 'You are eligible for free shipping!';
      freeShippingFillEl.style.width = '100%';
    } else {
      const diffRupees = Math.max(0, thresholdRupees - currentRupees);
      freeShippingTextEl.innerHTML = 'Add <strong>Rs. ' + diffRupees.toLocaleString() + '</strong> more for free shipping!';
      const pct = Math.min(100, Math.max(0, Math.round((currentRupees / thresholdRupees) * 100)));
      freeShippingFillEl.style.width = pct + '%';
    }
  }

  function renderCartDrawer(cart) {
    if (!drawerItemsContainer) return;
    if (!cart || typeof cart !== 'object') return;

    const rawItems = Array.isArray(cart.items) ? cart.items : [];
    // Filter strictly to items that have quantity > 0
    const validItems = rawItems.filter(item => item && Number(item.quantity) > 0);

    // Calculate total price in cents robustly
    let rawTotalPrice = 0;
    if (typeof cart.total_price === 'number' && !isNaN(cart.total_price)) {
      rawTotalPrice = cart.total_price;
    } else {
      rawTotalPrice = validItems.reduce((sum, it) => {
        const itemTotal = Number(it.final_line_price ?? it.line_price ?? (Number(it.price || 0) * Number(it.quantity || 1))) || 0;
        return sum + itemTotal;
      }, 0);
    }

    const totalQty = (typeof cart.item_count === 'number' && !isNaN(cart.item_count))
      ? cart.item_count
      : validItems.reduce((sum, it) => sum + (Number(it.quantity) || 0), 0);

    // Update cart badge counts across entire page
    document.querySelectorAll('.gp-cart-badge, #cart-drawer-count').forEach(b => {
      b.textContent = String(totalQty);
    });

    // Update Free Shipping Progress Bar & Text dynamically
    updateFreeShippingDisplay(rawTotalPrice, validItems.length > 0);

    // Update Checkout Button Subtotal
    const checkoutTextBtn = document.getElementById('cart-drawer-checkout-text');
    if (checkoutTextBtn) {
      const rupees = Math.round(rawTotalPrice / 100);
      const safeRupees = isNaN(rupees) ? 0 : Math.max(0, rupees);
      checkoutTextBtn.textContent = 'RS.' + safeRupees.toLocaleString() + ' PKR';
    }

    // Dynamic WhatsApp Support Link with Current Subtotal
    const waBtn = document.getElementById('gp-drawer-wa-link');
    if (waBtn) {
      const baseWaNum = (window.GPTheme && window.GPTheme.whatsappNumber) || '923147733316';
      const cleanNum = baseWaNum.replace(/[^0-9]/g, '');
      const currentRupees = Math.round(rawTotalPrice / 100);
      const msg = 'Hello Khalid Liaquat! I need assistance with my cart order (Subtotal: RS.' + currentRupees.toLocaleString() + ' PKR)';
      waBtn.href = 'https://wa.me/' + cleanNum;
    }

    // Toggle Drawer Footer visibility based on items presence
    const drawerFooter = document.querySelector('.gp-drawer-footer');

    // Restore saved promo code in input if present
    const savedDiscount = sessionStorage.getItem('gp_cart_discount');
    const discountInput = document.getElementById('gp-cart-discount-input');
    if (savedDiscount && discountInput && !discountInput.value) {
      discountInput.value = savedDiscount;
    }

    // Render Items or Empty State
    if (validItems.length === 0) {
      if (drawerFooter) drawerFooter.style.display = 'none';
      drawerItemsContainer.innerHTML = '<div class="gp-empty-cart">' +
        '<div class="gp-empty-icon">&#128274;</div>' +
        '<h4>Your cart is empty</h4>' +
        '<p>Explore our catalog and add your favorite skincare essentials.</p>' +
        '<button type="button" class="gp-btn-continue-shop gp-close-drawer">Continue Shopping</button>' +
        '</div>';
      return;
    } else {
      if (drawerFooter) drawerFooter.style.display = 'block';
    }

    let itemsHtml = '';
    validItems.forEach((item, index) => {
      const line = index + 1;
      const finalPrice = Number(item.final_line_price ?? item.line_price ?? (item.price * item.quantity)) || 0;
      const origPrice = Number(item.original_line_price ?? finalPrice) || finalPrice;
      const hasDiscount = origPrice > finalPrice;
      const imgUrl = item.featured_image?.url || item.image || item.featured_image || '';
      const itemTitle = item.product_title || item.title || 'Khalid Liaquat Product';
      const variantTitle = cleanVariantTitle(item.variant_title);
      const itemKey = (item.key && typeof item.key === 'string') ? item.key : (item.id ? String(item.id) : '');
      const variantId = item.variant_id || item.id || '';

      itemsHtml += '<div class="gp-cart-item" data-line="' + line + '" data-key="' + escapeHtml(itemKey) + '" data-variant-id="' + escapeHtml(String(variantId)) + '">' +
        '<div class="gp-cart-item-img-wrap">' +
          (imgUrl ? '<img src="' + imgUrl + '" alt="' + escapeHtml(itemTitle) + '" width="80" height="80" loading="lazy">' : '<div style="width:80px;height:80px;background:#f3f4f6;display:flex;align-items:center;justify-content:center;font-size:10px;color:#9ca3af;">No Image</div>') +
        '</div>' +
        '<div class="gp-cart-item-main">' +
          '<div class="gp-cart-item-header">' +
            '<div>' +
              '<h4 class="gp-cart-item-title">' + escapeHtml(itemTitle) + '</h4>' +
              (variantTitle ? '<div style="font-size:11px;color:#6b7280;margin-top:2px;">' + escapeHtml(variantTitle) + '</div>' : '') +
            '</div>' +
            '<div class="gp-cart-item-pricing">' +
              '<div class="gp-cart-item-price">' + formatMoneyPKR(finalPrice) + '</div>' +
              (hasDiscount ? '<div class="gp-cart-item-orig">' + formatMoneyPKR(origPrice) + '</div>' : '') +
            '</div>' +
          '</div>' +
          '<div class="gp-cart-item-actions">' +
            '<div class="gp-cart-qty-pill">' +
              '<button type="button" class="gp-qty-btn gp-qty-minus" data-key="' + escapeHtml(itemKey) + '" data-variant-id="' + escapeHtml(String(variantId)) + '" data-line="' + line + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
              '<span class="gp-qty-val">' + item.quantity + '</span>' +
              '<button type="button" class="gp-qty-btn gp-qty-plus" data-key="' + escapeHtml(itemKey) + '" data-variant-id="' + escapeHtml(String(variantId)) + '" data-line="' + line + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">&#43;</button>' +
            '</div>' +
            '<button type="button" class="gp-cart-remove-link" data-key="' + escapeHtml(itemKey) + '" data-variant-id="' + escapeHtml(String(variantId)) + '" data-line="' + line + '">Remove</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    });

    drawerItemsContainer.innerHTML = itemsHtml;
  }

  function fetchAndRefreshCart(openDrawer = false) {
    if (openDrawer) {
      openCartDrawer();
    }
    const cartUrl = getShopifyRoute('cart.js') + '?_t=' + Date.now();

    return fetch(cartUrl, {
      cache: 'no-store',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(res => {
        if (!res.ok) throw new Error('Cart fetch error: ' + res.status);
        return res.json();
      })
      .then(cart => {
        if (cart && (Array.isArray(cart.items) || typeof cart.total_price === 'number')) {
          renderCartDrawer(cart);
        }
        if (openDrawer) {
          openCartDrawer();
        }
        return cart;
      })
      .catch(err => {
        console.error('Cart refresh error:', err);
      });
  }

  // Bulletproof multi-strategy Cart Item Quantity and Removal Modifier for Shopify
  async function changeShopifyCartItem(key, line, newQuantity, variantId) {
    const changeUrl = getShopifyRoute('cart/change.js');
    const updateUrl = getShopifyRoute('cart/update.js');
    const targetQty = Math.max(0, parseInt(newQuantity, 10) || 0);
    const lineNum = parseInt(line, 10);
    const cleanKey = (key && typeof key === 'string') ? key.trim() : '';
    const cleanVariantId = (variantId && typeof variantId === 'string') ? variantId.trim() : (variantId ? String(variantId) : '');

    // Strategy 1: Shopify Preferred - Unique line item key to change.js
    if (cleanKey) {
      try {
        const res = await fetch(changeUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ id: cleanKey, quantity: targetQty })
        });
        if (res.ok) {
          const cartJson = await res.json();
          if (cartJson && (Array.isArray(cartJson.items) || typeof cartJson.total_price === 'number' || typeof cartJson.item_count === 'number')) {
            return cartJson;
          }
        }
      } catch (err) {
        console.warn('Key-based change error:', err);
      }
    }

    // Strategy 2: Line index change.js
    if (!isNaN(lineNum) && lineNum > 0) {
      try {
        const res = await fetch(changeUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ line: lineNum, quantity: targetQty })
        });
        if (res.ok) {
          const cartJson = await res.json();
          if (cartJson && (Array.isArray(cartJson.items) || typeof cartJson.total_price === 'number' || typeof cartJson.item_count === 'number')) {
            return cartJson;
          }
        }
      } catch (err) {
        console.warn('Line-based change error:', err);
      }
    }

    // Strategy 3: Update.js with updates map
    if (cleanKey || cleanVariantId) {
      try {
        const updatesObj = {};
        if (cleanKey) updatesObj[cleanKey] = targetQty;
        if (cleanVariantId && cleanVariantId !== cleanKey) updatesObj[cleanVariantId] = targetQty;

        const res = await fetch(updateUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ updates: updatesObj })
        });
        if (res.ok) {
          const cartJson = await res.json();
          if (cartJson && (Array.isArray(cartJson.items) || typeof cartJson.total_price === 'number' || typeof cartJson.item_count === 'number')) {
            return cartJson;
          }
        }
      } catch (err) {
        console.warn('cart/update.js error:', err);
      }
    }

    // Strategy 4: FormData fallback
    try {
      const formData = new FormData();
      if (cleanKey) {
        formData.append('id', cleanKey);
      } else if (!isNaN(lineNum) && lineNum > 0) {
        formData.append('line', String(lineNum));
      } else if (cleanVariantId) {
        formData.append('id', cleanVariantId);
      }
      formData.append('quantity', String(targetQty));

      const res = await fetch(changeUrl, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });
      if (res.ok) {
        const cartJson = await res.json();
        if (cartJson && (Array.isArray(cartJson.items) || typeof cartJson.total_price === 'number' || typeof cartJson.item_count === 'number')) {
          return cartJson;
        }
      }
    } catch (err) {
      console.warn('FormData change error:', err);
    }

    // Strategy 5: URLSearchParams fallback
    try {
      const params = new URLSearchParams();
      if (cleanKey) {
        params.append('id', cleanKey);
      } else if (!isNaN(lineNum) && lineNum > 0) {
        params.append('line', String(lineNum));
      } else if (cleanVariantId) {
        params.append('id', cleanVariantId);
      }
      params.append('quantity', String(targetQty));

      const res = await fetch(changeUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: params.toString()
      });
      if (res.ok) {
        const cartJson = await res.json();
        if (cartJson && (Array.isArray(cartJson.items) || typeof cartJson.total_price === 'number' || typeof cartJson.item_count === 'number')) {
          return cartJson;
        }
      }
    } catch (err) {
      console.warn('URLSearchParams change error:', err);
    }

    // Fallback: Fetch fresh cart snapshot
    return fetchAndRefreshCart(false);
  }

  // Bulletproof multi-strategy Add to Cart for Shopify AJAX API
  async function addShopifyCartItem(variantId, quantity, formEl, submitBtn) {
    const originalText = submitBtn ? submitBtn.innerHTML : 'ADD TO CART';

    // Theme Editor previews can use a demo product/variant that is sold out.
    // Do not call the live cart API from the editor, which can create a
    // misleading "sold out" error in the editor preview.
    if (isDesignMode()) {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
      }
      return;
    }

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerHTML = 'Adding...';
    }

    let varId = parseInt(variantId, 10);
    // If varId is missing or NaN, try to resolve from form elements or variant helper
    if (!varId || isNaN(varId)) {
      const vInput = formEl ? formEl.querySelector('input[name="id"], select[name="id"]') : document.getElementById('gp-selected-variant-id');
      if (vInput && vInput.value) {
        varId = parseInt(vInput.value, 10);
      }
    }
    if (!varId || isNaN(varId)) {
      if (typeof findMatchingVariant === 'function') {
        const matched = findMatchingVariant();
        if (matched && matched.id) varId = matched.id;
      }
    }

    const qty = Math.max(1, parseInt(quantity, 10) || 1);

    if (!varId || isNaN(varId)) {
      console.error('Invalid variant ID for add to cart:', variantId);
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
      }
      alert('Please select an available product option before adding to cart.');
      return;
    }

    const addUrl = getShopifyRoute('cart/add.js');
    let cartUpdated = false;
    let errorMessage = '';

    // Strategy 1: JSON payload with id & quantity
    try {
      const res = await fetch(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: varId,
          quantity: qty
        })
      });

      if (res.ok) {
        cartUpdated = true;
      } else {
        const data = await res.json().catch(() => ({}));
        if (data && (data.description || data.message)) {
          errorMessage = data.description || data.message;
        }
      }
    } catch (err) {
      console.warn('JSON add to cart error:', err);
    }

    // Strategy 2: items array JSON format
    if (!cartUpdated && !errorMessage) {
      try {
        const res = await fetch(addUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [{ id: varId, quantity: qty }]
          })
        });
        if (res.ok) {
          cartUpdated = true;
        } else {
          const data = await res.json().catch(() => ({}));
          if (data && (data.description || data.message)) {
            errorMessage = data.description || data.message;
          }
        }
      } catch (err) {
        console.warn('JSON items add to cart error:', err);
      }
    }

    // Strategy 3: Standard Shopify FormData
    if (!cartUpdated && !errorMessage) {
      try {
        const fd = formEl ? new FormData(formEl) : new FormData();
        fd.set('id', String(varId));
        fd.set('quantity', String(qty));

        const res = await fetch(addUrl, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: fd
        });

        if (res.ok) {
          cartUpdated = true;
        } else {
          const data = await res.json().catch(() => ({}));
          if (data && (data.description || data.message)) {
            errorMessage = data.description || data.message;
          }
        }
      } catch (err) {
        console.warn('FormData add to cart error:', err);
      }
    }

    if (cartUpdated) {
      openCartDrawer();
      await fetchAndRefreshCart(true);
      if (submitBtn) {
        submitBtn.innerHTML = '&#10003; Added!';
        setTimeout(() => {
          submitBtn.disabled = false;
          submitBtn.innerHTML = originalText;
        }, 1200);
      }
    } else {
      console.warn('Add to cart failed for variant ID:', varId, errorMessage);
      if (submitBtn) {
        if (errorMessage && errorMessage.toLowerCase().includes('sold out')) {
          // Shopify's cart API is authoritative. Re-check the selected variant
          // before changing the button state so a stale UI cannot remain "Sold Out".
          const selectedId = variantIdInput ? parseInt(variantIdInput.value, 10) : varId;
          const selectedVariant = productVariants.find(v => Number(v.id) === Number(selectedId));
          const stillAvailable = selectedVariant ? isVariantAvailable(selectedVariant) : false;
          submitBtn.innerHTML = stillAvailable ? originalText : 'Sold Out';
          submitBtn.disabled = !stillAvailable;
        } else {
          submitBtn.disabled = false;
          submitBtn.innerHTML = originalText;
          if (errorMessage) {
            alert(errorMessage);
          }
        }
      }
    }
  }

  // Intercept all Add to Cart Form Submissions with AJAX
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form || !(form instanceof HTMLFormElement)) return;
    const action = (form.getAttribute('action') || form.action || '').toLowerCase();
    const isCartAdd = action.includes('/cart/add') || form.classList.contains('gp-add-form') || form.classList.contains('gp-product-card-form') || form.id === 'gp-product-form';

    if (isCartAdd) {
      e.preventDefault();
      e.stopPropagation();

      if (isDesignMode()) return;

      const submitBtn = form.querySelector('button[type="submit"], .gp-btn-add, .gp-btn-add-main, #gp-add-to-cart-btn');
      const idInput = form.querySelector('input[name="id"], select[name="id"]');
      const qtyInput = form.querySelector('input[name="quantity"]');
      const formData = new FormData(form);
      const rawId = (idInput ? idInput.value : formData.get('id')) || form.getAttribute('data-variant-id') || (submitBtn ? submitBtn.getAttribute('data-variant-id') : '');
      const rawQty = (qtyInput ? qtyInput.value : formData.get('quantity')) || '1';

      addShopifyCartItem(rawId, rawQty, form, submitBtn);
    }
  }, true);

  // Global Event Delegation for all Cart Actions
  document.addEventListener('click', async (e) => {
    const target = e.target;
    if (!target) return;

    // 0. Direct Add to Cart Button Click (Collection cards, product pages, recommendations)
    const addBtn = target.closest('.gp-btn-add, .gp-btn-add-main, #gp-add-to-cart-btn');
    if (addBtn && !addBtn.classList.contains('gp-btn-continue-shop')) {
      if (isDesignMode()) {
        e.preventDefault();
        return;
      }
      if (addBtn.tagName === 'A' && !addBtn.hasAttribute('data-variant-id')) {
        return; // Allow standard link navigation for "Browse All Products" or "View Product" links
      }
      const form = addBtn.closest('form');
      const currentInputId = form ? (form.querySelector('input[name="id"]')?.value || '') : '';
      const rawId = currentInputId || addBtn.getAttribute('data-variant-id') || (form ? form.getAttribute('data-variant-id') : '');
      const rawQty = form ? (form.querySelector('input[name="quantity"]')?.value || '1') : '1';
      if (rawId) {
        e.preventDefault();
        e.stopPropagation();
        addShopifyCartItem(rawId, rawQty, form, addBtn);
        return;
      }
    }

    // 1. Cart Open Triggers
    const openTrigger = target.closest('.gp-cart-trigger, .gp-header-cart, [data-cart-drawer-toggle]');
    if (openTrigger) {
      e.preventDefault();
      openCartDrawer();
      fetchAndRefreshCart(true);
      return;
    }

    // 2. Cart Close Buttons
    const closeTrigger = target.closest('.gp-close-drawer, .gp-btn-continue-shop');
    if (closeTrigger) {
      e.preventDefault();
      closeCartDrawer();
      return;
    }

    // 3. Cart Drawer Backdrop Click
    if (target === cartDrawer && !target.closest('.gp-drawer')) {
      closeCartDrawer();
      return;
    }

    // 4. Quantity Buttons (+ / -)
    const qtyBtn = target.closest('.gp-qty-btn');
    if (qtyBtn) {
      e.preventDefault();
      e.stopPropagation();

      if (isCartBusy) return;
      setCartBusy(true);

      const cartItemEl = qtyBtn.closest('.gp-cart-item');
      const key = qtyBtn.getAttribute('data-key') || cartItemEl?.getAttribute('data-key') || '';
      const variantId = qtyBtn.getAttribute('data-variant-id') || cartItemEl?.getAttribute('data-variant-id') || '';
      const line = qtyBtn.getAttribute('data-line') || cartItemEl?.getAttribute('data-line') || '';
      const lineNum = parseInt(line, 10);

      // Compute dynamic index from DOM in case lines shifted
      const allItemEls = Array.from(document.querySelectorAll('#gp-drawer-items .gp-cart-item'));
      const domIndex = allItemEls.indexOf(cartItemEl) + 1;
      const finalLine = (domIndex > 0) ? domIndex : (lineNum > 0 ? lineNum : 1);

      const qtyValEl = cartItemEl?.querySelector('.gp-qty-val');
      const currentQty = parseInt(qtyValEl?.textContent || qtyBtn.getAttribute('data-qty') || '1', 10) || 1;

      let targetQty = 1;
      const isPlus = qtyBtn.classList.contains('gp-qty-plus') || qtyBtn.textContent.includes('+') || qtyBtn.innerHTML.includes('+') || qtyBtn.innerHTML.includes('&#43;');
      const isMinus = qtyBtn.classList.contains('gp-qty-minus') || qtyBtn.textContent.includes('-') || qtyBtn.innerHTML.includes('&minus;') || qtyBtn.innerHTML.includes('−') || qtyBtn.innerHTML.includes('-');

      if (isPlus) {
        targetQty = currentQty + 1;
      } else if (isMinus) {
        targetQty = Math.max(0, currentQty - 1);
      } else {
        targetQty = Math.max(0, parseInt(qtyBtn.getAttribute('data-qty') || '1', 10));
      }

      // Instant optimistic UI feedback
      if (targetQty === 0) {
        if (cartItemEl) {
          cartItemEl.style.transition = 'opacity 0.2s ease, transform 0.2s ease';
          cartItemEl.style.opacity = '0.2';
          cartItemEl.style.pointerEvents = 'none';
        }
      } else {
        if (qtyValEl) qtyValEl.textContent = String(targetQty);
        if (cartItemEl) cartItemEl.style.opacity = '0.6';
      }
      qtyBtn.disabled = true;

      try {
        const updatedCart = await changeShopifyCartItem(key, finalLine, targetQty, variantId);
        if (updatedCart && (Array.isArray(updatedCart.items) || typeof updatedCart.total_price === 'number')) {
          renderCartDrawer(updatedCart);
        } else {
          await fetchAndRefreshCart(false);
        }
      } catch (err) {
        console.error('Failed to change quantity:', err);
        await fetchAndRefreshCart(false);
      } finally {
        if (cartItemEl) {
          cartItemEl.style.opacity = '1';
          cartItemEl.style.pointerEvents = 'auto';
        }
        qtyBtn.disabled = false;
        setCartBusy(false);
      }
      return;
    }

    // 5. Remove Item Link
    const removeBtn = target.closest('.gp-cart-remove-link');
    if (removeBtn) {
      e.preventDefault();
      e.stopPropagation();

      if (isCartBusy) return;
      setCartBusy(true);

      const cartItemEl = removeBtn.closest('.gp-cart-item');
      const key = removeBtn.getAttribute('data-key') || cartItemEl?.getAttribute('data-key') || '';
      const variantId = removeBtn.getAttribute('data-variant-id') || cartItemEl?.getAttribute('data-variant-id') || '';
      const line = removeBtn.getAttribute('data-line') || cartItemEl?.getAttribute('data-line') || '';
      const lineNum = parseInt(line, 10);

      const allItemEls = Array.from(document.querySelectorAll('#gp-drawer-items .gp-cart-item'));
      const domIndex = allItemEls.indexOf(cartItemEl) + 1;
      const finalLine = (domIndex > 0) ? domIndex : (lineNum > 0 ? lineNum : 1);

      if (cartItemEl) {
        cartItemEl.style.transition = 'opacity 0.2s ease, transform 0.2s ease';
        cartItemEl.style.opacity = '0.2';
        cartItemEl.style.transform = 'translateX(12px)';
        cartItemEl.style.pointerEvents = 'none';
      }
      removeBtn.disabled = true;

      try {
        const updatedCart = await changeShopifyCartItem(key, finalLine, 0, variantId);
        if (updatedCart && (Array.isArray(updatedCart.items) || typeof updatedCart.total_price === 'number')) {
          renderCartDrawer(updatedCart);
        } else {
          await fetchAndRefreshCart(false);
        }
      } catch (err) {
        console.error('Failed to remove cart item:', err);
        await fetchAndRefreshCart(false);
      } finally {
        if (cartItemEl) {
          cartItemEl.style.opacity = '1';
          cartItemEl.style.transform = '';
          cartItemEl.style.pointerEvents = 'auto';
        }
        removeBtn.disabled = false;
        setCartBusy(false);
      }
      return;
    }

    // 6. In-Drawer Discount Code Application
    const discountBtn = target.closest('#gp-apply-discount-btn');
    if (discountBtn) {
      e.preventDefault();
      const discountInput = document.getElementById('gp-cart-discount-input');
      const discountStatus = document.getElementById('gp-discount-status');
      const code = (discountInput ? discountInput.value.trim() : '').toUpperCase();

      if (!code) {
        if (discountStatus) {
          discountStatus.textContent = 'Please enter a valid coupon code.';
          discountStatus.className = 'gp-discount-status error';
          discountStatus.style.display = 'block';
        }
        return;
      }

      sessionStorage.setItem('gp_cart_discount', code);

      if (discountStatus) {
        discountStatus.textContent = '✓ Code ' + code + ' applied! Discount will appear at checkout.';
        discountStatus.className = 'gp-discount-status success';
        discountStatus.style.display = 'block';
      }

      const checkoutBtn = document.getElementById('gp-checkout-btn') || document.querySelector('.gp-btn-checkout');
      if (checkoutBtn) {
        let baseHref = checkoutBtn.getAttribute('href') || '/checkout';
        baseHref = baseHref.split('?')[0];
        checkoutBtn.setAttribute('href', baseHref + '?discount=' + encodeURIComponent(code));
      }
      return;
    }

    // 7. Order Note Toggle
    const noteToggle = target.closest('#gp-toggle-note-btn');
    if (noteToggle && noteContainer) {
      e.preventDefault();
      const isHidden = noteContainer.style.display === 'none' || !noteContainer.style.display;
      noteContainer.style.display = isHidden ? 'block' : 'none';
      if (isHidden && noteInput) noteInput.focus();
      return;
    }

    // 8. Checkout Button Click: Flush unsaved order note and append promo code
    const checkoutBtn = target.closest('#gp-checkout-btn, .gp-btn-checkout');
    if (checkoutBtn) {
      if (isDesignMode()) {
        e.preventDefault();
        e.stopPropagation();
        alert('Checkout redirect is disabled in Shopify Theme Editor preview. On your live store, this redirects directly to checkout.');
        return;
      }

      const noteVal = noteInput ? noteInput.value.trim() : '';
      const savedDiscount = sessionStorage.getItem('gp_cart_discount');
      let targetHref = checkoutBtn.getAttribute('href') || '/checkout';
      if (savedDiscount && !targetHref.includes('discount=')) {
        const sep = targetHref.includes('?') ? '&' : '?';
        targetHref += sep + 'discount=' + encodeURIComponent(savedDiscount);
        checkoutBtn.setAttribute('href', targetHref);
      }

      if (noteVal) {
        e.preventDefault();
        checkoutBtn.innerHTML = 'Securing Checkout...';
        const updateUrl = getShopifyRoute('cart/update.js');
        fetch(updateUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ note: noteVal })
        }).catch(err => console.warn('Note save error on checkout:', err))
          .finally(() => {
            if (!isDesignMode()) {
              window.location.href = targetHref;
            }
          });
        return;
      }
    }

    // Safeguard any other checkout links in Theme Editor preview
    const checkoutLink = target.closest('a[href*="/checkout"]');
    if (checkoutLink && isDesignMode()) {
      e.preventDefault();
      e.stopPropagation();
      alert('Checkout redirect is disabled in Shopify Theme Editor preview. On your live store, this redirects directly to checkout.');
      return;
    }
  });

  // Discount code Enter key listener
  const discountInput = document.getElementById('gp-cart-discount-input');
  if (discountInput) {
    discountInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        const discountBtn = document.getElementById('gp-apply-discount-btn');
        if (discountBtn) discountBtn.click();
      }
    });
  }

  // Debounced Cart Order Note Input Saver
  let noteDebounce = null;
  if (noteInput) {
    noteInput.addEventListener('input', (e) => {
      clearTimeout(noteDebounce);
      noteDebounce = setTimeout(() => {
        const updateUrl = getShopifyRoute('cart/update.js');
        fetch(updateUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ note: e.target.value })
        }).catch(err => console.error('Order note save error:', err));
      }, 500);
    });
  }

  // Hydrate cart drawer and free shipping bar immediately on page load
  fetchAndRefreshCart(false);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => fetchAndRefreshCart(false));
  }

  // 4. Mobile Menu Drawer open/close
  const mobileDrawer = document.getElementById('gp-mobile-drawer');
  const mobileToggles = document.querySelectorAll('.gp-mobile-toggle');
  const closeMobileBtn = document.querySelector('.gp-close-mobile-drawer');

  mobileToggles.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (mobileDrawer) {
        mobileDrawer.classList.add('active');
        mobileDrawer.setAttribute('aria-hidden', 'false');
      }
    });
  });

  if (closeMobileBtn) {
    closeMobileBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (mobileDrawer) {
        mobileDrawer.classList.remove('active');
        mobileDrawer.setAttribute('aria-hidden', 'true');
      }
    });
  }

  if (mobileDrawer) {
    mobileDrawer.addEventListener('click', (e) => {
      if (e.target === mobileDrawer) {
        mobileDrawer.classList.remove('active');
        mobileDrawer.setAttribute('aria-hidden', 'true');
      }
    });
  }

  // 5. Separate Matching Products (predictive only)
  // IMPORTANT: This dropdown is independent from the full search page.
  // Clicking a matching product opens that product directly; it never submits a search.
  const searchModal = document.getElementById('gp-search-modal');
  const searchTriggers = document.querySelectorAll('.gp-search-trigger');
  const closeSearchBtn = document.querySelector('.gp-close-search');
  const searchInput = document.getElementById('gp-search-modal-input') || document.getElementById('gp-search-input');
  const searchLiveResults = document.getElementById('gp-search-live-results');

  function renderMatchingProducts(query, items) {
    if (!searchLiveResults) return;
    const q = (query || '').trim();
    if (!q) {
      searchLiveResults.innerHTML = '';
      searchLiveResults.classList.remove('has-results');
      return;
    }

    if (!items.length) {
      searchLiveResults.innerHTML = '<div class="gp-search-live-empty">No matching products found for &ldquo;' + escapeHtml(q) + '&rdquo;.</div>';
      searchLiveResults.classList.add('has-results');
      return;
    }

    let html = '<div class="gp-search-live-header">';
    html += '<span>Matching Products</span>';
    html += '<span class="gp-search-live-hint">Click a product to open it</span>';
    html += '</div><div class="gp-search-live-list">';

    items.forEach(item => {
      const safeUrl = item.url || '#';
      html += '<a href="' + safeUrl + '" class="gp-search-live-item" data-matching-product="true">';
      if (item.img) {
        html += '<img src="' + item.img + '" alt="' + escapeHtml(item.title) + '" class="gp-search-live-img" loading="lazy" width="48" height="48" />';
      }
      html += '<div class="gp-search-live-info">';
      html += '<h4 class="gp-search-live-title">' + escapeHtml(item.title) + '</h4>';
      if (item.price) html += '<div class="gp-search-live-price">' + escapeHtml(item.price) + '</div>';
      html += '</div><span class="gp-search-live-arrow">&rarr;</span></a>';
    });

    html += '</div>';
    searchLiveResults.innerHTML = html;
    searchLiveResults.classList.add('has-results');
  }

  let searchDebounceTimer = null;
  function handleSearchInput(query) {
    clearTimeout(searchDebounceTimer);
    const q = (query || '').trim();
    if (!q) {
      renderMatchingProducts('', []);
      return;
    }

    searchDebounceTimer = setTimeout(() => {
      const predictUrl = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=12&resources[options][unavailable_products]=show';
      fetch(predictUrl, { credentials: 'same-origin' })
        .then(res => {
          if (!res.ok) throw new Error('Fetch error');
          return res.json();
        })
        .then(data => {
          const products = data?.resources?.results?.products || [];
          const formatted = products
            .filter(p => p && p.url)
            .map(p => ({
              title: p.title || '',
              url: p.url,
              img: p.featured_image?.url || p.image || '',
              price: p.price ? ('Rs. ' + Math.round(parseFloat(p.price)).toLocaleString()) : ''
            }));
          renderMatchingProducts(q, formatted);
        })
        .catch(() => renderMatchingProducts(q, []));
    }, 180);
  }

  searchTriggers.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      searchModal?.classList.add('active');
      searchModal?.setAttribute('aria-hidden', 'false');
      setTimeout(() => { searchInput?.focus(); }, 100);
    });
  });

  if (closeSearchBtn) {
    closeSearchBtn.addEventListener('click', () => {
      searchModal?.classList.remove('active');
      searchModal?.setAttribute('aria-hidden', 'true');
    });
  }

  if (searchModal) {
    searchModal.addEventListener('click', (e) => {
      if (e.target === searchModal) {
        searchModal.classList.remove('active');
        searchModal.setAttribute('aria-hidden', 'true');
      }
    });
  }

  // Matching product clicks are intentionally direct product navigation.
  if (searchLiveResults) {
    searchLiveResults.addEventListener('click', (e) => {
      const link = e.target.closest('a[data-matching-product="true"]');
      if (!link || !link.href) return;
      e.preventDefault();
      window.location.href = link.href;
    });
  }

  if (searchInput) {
    searchInput.addEventListener('input', (e) => handleSearchInput(e.target.value));
  }

  // The Search button / Enter is the ONLY action that performs the full search.
  const searchModalForm = document.getElementById('gp-search-modal-form');
  if (searchModalForm) {
    searchModalForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const input = searchModalForm.querySelector('input[name="q"]');
      const q = (input?.value || '').trim();
      if (!q) return;
      window.location.href = '/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
    });
  }

  document.querySelectorAll('.gp-mobile-search-form').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const input = form.querySelector('input[name="q"]');
      const q = (input?.value || '').trim();
      if (!q) return;
      window.location.href = '/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
    });
  });

  // 6. Global ESC key to close active drawers/modals
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeCartDrawer();
      mobileDrawer?.classList.remove('active');
      searchModal?.classList.remove('active');
      filterPanel?.classList.remove('active');
      document.body.classList.remove('gp-drawer-open');
      document.body.style.overflow = '';
      filterBtns.forEach(btn => {
        btn.classList.remove('active');
        btn.setAttribute('aria-expanded', 'false');
      });
    }
  });

  // 7. Announcement bar slider
  const slider = document.querySelector('[data-announcement-slider]');
  if (slider) {
    const slides = slider.querySelectorAll('.gp-announcement-slide');
    const prevBtn = slider.querySelector('.gp-slide-prev');
    const nextBtn = slider.querySelector('.gp-slide-next');
    let currentIndex = 0;
    const speed = (parseInt(slider.getAttribute('data-speed')) || 4) * 1000;

    function showSlide(index) {
      slides.forEach((slide, i) => {
        slide.classList.toggle('active', i === index);
      });
    }

    if (slides.length > 1) {
      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          currentIndex = (currentIndex - 1 + slides.length) % slides.length;
          showSlide(currentIndex);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          currentIndex = (currentIndex + 1) % slides.length;
          showSlide(currentIndex);
        });
      }
      setInterval(() => {
        currentIndex = (currentIndex + 1) % slides.length;
        showSlide(currentIndex);
      }, speed);
    }
  }

  // 8. Hero Slideshow Carousel Controller
  document.querySelectorAll('.gp-hero-slider-section').forEach(sliderSection => {
    const track = sliderSection.querySelector('.gp-slides-track');
    const slides = sliderSection.querySelectorAll('.gp-hero-slide');
    const dots = sliderSection.querySelectorAll('.gp-dot-btn');
    const prevBtn = sliderSection.querySelector('.gp-slider-prev');
    const nextBtn = sliderSection.querySelector('.gp-slider-next');
    const isAutoplay = sliderSection.getAttribute('data-autoplay') === 'true';
    const speedSeconds = parseInt(sliderSection.getAttribute('data-speed')) || 6;
    let currentIdx = 0;
    let autoTimer = null;

    if (slides.length <= 1) return;

    function goToSlide(newIdx, smooth) {
      if (smooth === undefined) smooth = true;
      currentIdx = (newIdx + slides.length) % slides.length;

      if (track) {
        track.style.transition = smooth ? 'transform 0.4s cubic-bezier(0.25, 1, 0.5, 1)' : 'none';
        track.style.transform = 'translateX(-' + (currentIdx * 100) + '%)';
      }

      slides.forEach((slide, i) => {
        slide.classList.toggle('gp-slide-active', i === currentIdx);
        slide.classList.toggle('active', i === currentIdx);
      });

      dots.forEach((dot, i) => {
        if (i === currentIdx) {
          dot.style.width = '24px';
          dot.style.background = '#D32F2F';
          dot.classList.add('gp-dot-active', 'active');
        } else {
          dot.style.width = '8px';
          dot.style.background = 'rgba(255,255,255,0.6)';
          dot.classList.remove('gp-dot-active', 'active');
        }
      });
    }

    const swipeWrapper = sliderSection.querySelector('.gp-hero-carousel-wrapper') || sliderSection;
    let isDragging = false;
    let startX = 0;
    let startY = 0;
    let currentX = 0;
    let deltaX = 0;
    let deltaY = 0;
    let isHorizontalGesture = null;

    function handleDragStart(e) {
      isDragging = true;
      startX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
      startY = e.type.includes('touch') ? e.touches[0].clientY : e.clientY;
      currentX = startX;
      deltaX = 0;
      deltaY = 0;
      isHorizontalGesture = null;
      stopAutoTimer();
    }

    function handleDragMove(e) {
      if (!isDragging) return;
      currentX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
      const curY = e.type.includes('touch') ? e.touches[0].clientY : e.clientY;
      deltaX = currentX - startX;
      deltaY = curY - startY;

      if (isHorizontalGesture === null) {
        if (Math.abs(deltaX) > 8 || Math.abs(deltaY) > 8) {
          isHorizontalGesture = Math.abs(deltaX) > Math.abs(deltaY);
        }
      }

      if (isHorizontalGesture) {
        if (e.cancelable) e.preventDefault();
      }
    }

    function handleDragEnd() {
      if (!isDragging) return;
      isDragging = false;

      const threshold = 40;
      if (deltaX < -threshold) {
        goToSlide(currentIdx + 1);
      } else if (deltaX > threshold) {
        goToSlide(currentIdx - 1);
      } else {
        goToSlide(currentIdx);
      }

      if (Math.abs(deltaX) > 10) {
        const preventClick = function(clickEv) {
          clickEv.preventDefault();
          clickEv.stopPropagation();
          swipeWrapper.removeEventListener('click', preventClick, true);
        };
        swipeWrapper.addEventListener('click', preventClick, true);
        setTimeout(() => {
          swipeWrapper.removeEventListener('click', preventClick, true);
        }, 150);
      }

      deltaX = 0;
      isHorizontalGesture = null;
      resetAutoTimer();
    }

    swipeWrapper.addEventListener('touchstart', handleDragStart, { passive: true });
    swipeWrapper.addEventListener('touchmove', handleDragMove, { passive: false });
    swipeWrapper.addEventListener('touchend', handleDragEnd, { passive: true });
    swipeWrapper.addEventListener('touchcancel', handleDragEnd, { passive: true });

    swipeWrapper.addEventListener('mousedown', handleDragStart);
    window.addEventListener('mousemove', handleDragMove);
    window.addEventListener('mouseup', handleDragEnd);

    // Shopify Theme Customizer Live Preview hooks
    document.addEventListener('shopify:block:select', (e) => {
      if (!sliderSection.contains(e.target)) return;
      const slideEl = e.target.closest('.gp-hero-slide');
      if (slideEl) {
        const idx = Array.from(slides).indexOf(slideEl);
        if (idx !== -1) {
          goToSlide(idx);
          stopAutoTimer();
        }
      }
    });

    document.addEventListener('shopify:block:deselect', (e) => {
      if (!sliderSection.contains(e.target)) return;
      startAutoTimer();
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        goToSlide(currentIdx - 1);
        resetAutoTimer();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        goToSlide(currentIdx + 1);
        resetAutoTimer();
      });
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        const targetIdx = parseInt(dot.getAttribute('data-target-slide')) || 0;
        goToSlide(targetIdx);
        resetAutoTimer();
      });
    });

    function startAutoTimer() {
      if (!isAutoplay) return;
      stopAutoTimer();
      autoTimer = setInterval(() => {
        goToSlide(currentIdx + 1);
      }, speedSeconds * 1000);
    }

    function stopAutoTimer() {
      if (autoTimer) {
        clearInterval(autoTimer);
        autoTimer = null;
      }
    }

    function resetAutoTimer() {
      stopAutoTimer();
      startAutoTimer();
    }

    sliderSection.addEventListener('mouseenter', stopAutoTimer);
    sliderSection.addEventListener('mouseleave', startAutoTimer);

    startAutoTimer();
  });

  // 9. Gallery thumbnail switcher
  const thumbs = document.querySelectorAll('.gp-thumb');
  const mainImg = document.getElementById('gp-zoom-target');

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImg) {
        mainImg.src = thumb.getAttribute('data-large');
      }
    });
  });

  // 10. Quantity box handlers (Event Delegation)
  document.addEventListener('click', (e) => {
    const target = e.target;
    const minus = target.closest('.qty-minus');
    if (minus) {
      const box = minus.closest('.gp-qty-box');
      const input = box ? box.querySelector('input') : null;
      if (input) {
        let val = parseInt(input.value, 10) || 1;
        if (val > 1) {
          input.value = val - 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      return;
    }
    const plus = target.closest('.qty-plus');
    if (plus) {
      const box = plus.closest('.gp-qty-box');
      const input = box ? box.querySelector('input') : null;
      if (input) {
        let val = parseInt(input.value, 10) || 1;
        input.value = val + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }
  });

  // 11. Variant Option Pills Selector & Inventory/Availability Engine
  const variantPills = document.querySelectorAll('.gp-variant-pill');
  const variantIdInput = document.getElementById('gp-selected-variant-id');
  const addToCartBtn = document.getElementById('gp-add-to-cart-btn');
  const buyCodBtn = document.getElementById('gp-buy-cod-btn');
  const currentPriceEl = document.querySelector('.gp-current-price');
  const origPriceEl = document.querySelector('.gp-orig-price');
  const variantsDataEl = document.getElementById('gp-product-variants-data');

  let productVariants = [];
  if (variantsDataEl) {
    try {
      const rawJson = variantsDataEl.textContent || '[]';
      productVariants = JSON.parse(rawJson);
    } catch (err) {
      console.warn('Could not parse variants JSON', err);
    }
  }

  // Shopify's `variant.available` is the authoritative availability value.
  // Do not infer availability from inventory_quantity because inventory can be
  // unavailable for the current sales channel/location even when quantity exists.
  function isVariantAvailable(variant) {
    return Boolean(variant && variant.available === true);
  }

  function updateVariantUI(matchedVariant) {
    if (!matchedVariant) {
      if (addToCartBtn) {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'UNAVAILABLE';
      }
      if (buyCodBtn) buyCodBtn.disabled = true;
      return;
    }

    if (variantIdInput) {
      const selectedId = String(matchedVariant.id);
      variantIdInput.value = selectedId;
      variantIdInput.setAttribute('value', selectedId);
      const productForm = variantIdInput.closest('form');
      if (productForm) productForm.setAttribute('data-variant-id', selectedId);
      if (addToCartBtn) addToCartBtn.setAttribute('data-variant-id', selectedId);
      if (buyCodBtn) buyCodBtn.setAttribute('data-variant-id', selectedId);
    }

    if (currentPriceEl && matchedVariant.price !== undefined) {
      currentPriceEl.textContent = formatMoneyPKR(matchedVariant.price);
    }
    if (origPriceEl) {
      if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
        origPriceEl.textContent = formatMoneyPKR(matchedVariant.compare_at_price);
        origPriceEl.style.display = 'inline';
      } else {
        origPriceEl.style.display = 'none';
      }
    }

    const available = isVariantAvailable(matchedVariant);
    if (addToCartBtn) {
      if (available) {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = 'ADD TO CART';
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'SOLD OUT';
      }
    }

    if (buyCodBtn) {
      buyCodBtn.disabled = !available;
    }

    if (matchedVariant.featured_image && matchedVariant.featured_image.src) {
      const mainImg = document.getElementById('gp-zoom-target');
      if (mainImg) mainImg.src = matchedVariant.featured_image.src;
    }

    if (window.history && window.history.replaceState && !isDesignMode()) {
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(matchedVariant.id));
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }
  }

  function findMatchingVariant() {
    if (!productVariants || productVariants.length === 0) return null;
    if (productVariants.length === 1) return productVariants[0];

    const selectedOptions = [];
    document.querySelectorAll('.gp-option-group[data-option-index]').forEach(grp => {
      const activePill = grp.querySelector('.gp-variant-pill.active');
      if (activePill) {
        selectedOptions.push(activePill.getAttribute('data-value') || '');
      }
    });

    if (selectedOptions.length === 0) {
      const currentId = variantIdInput ? parseInt(variantIdInput.value, 10) : 0;
      if (currentId) {
        const found = productVariants.find(v => v.id === currentId);
        if (found) return found;
      }
      return productVariants.find(v => isVariantAvailable(v)) || productVariants[0];
    }

    return productVariants.find(v => {
      if (v.options && v.options.length === selectedOptions.length) {
        return v.options.every((opt, idx) => {
          return String(opt).trim().toLowerCase() === String(selectedOptions[idx]).trim().toLowerCase();
        });
      }
      if (v.option1 && selectedOptions[0]) {
        const match1 = String(v.option1).trim().toLowerCase() === String(selectedOptions[0]).trim().toLowerCase();
        const match2 = !selectedOptions[1] || !v.option2 || String(v.option2).trim().toLowerCase() === String(selectedOptions[1]).trim().toLowerCase();
        const match3 = !selectedOptions[2] || !v.option3 || String(v.option3).trim().toLowerCase() === String(selectedOptions[2]).trim().toLowerCase();
        return match1 && match2 && match3;
      }
      return false;
    });
  }

  // Initialize variant state on page load / refresh
  if (productVariants.length > 0) {
    let initialVariant = null;
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const urlVariantId = parseInt(urlParams.get('variant') || '0', 10);
      if (urlVariantId) {
        initialVariant = productVariants.find(v => v.id === urlVariantId);
      }
    } catch (e) {}

    if (!initialVariant && variantIdInput && variantIdInput.value) {
      const formVarId = parseInt(variantIdInput.value, 10);
      if (formVarId) {
        initialVariant = productVariants.find(v => v.id === formVarId);
      }
    }

    if (!initialVariant) {
      initialVariant = findMatchingVariant() || productVariants.find(v => isVariantAvailable(v)) || productVariants[0];
    }

    if (initialVariant) {
      if (initialVariant.options && initialVariant.options.length > 0) {
        initialVariant.options.forEach((optVal, optIdx) => {
          const group = document.querySelector('.gp-option-group[data-option-index="' + optIdx + '"]');
          if (group) {
            group.querySelectorAll('.gp-variant-pill').forEach(p => {
              const pVal = p.getAttribute('data-value') || '';
              if (String(pVal).trim().toLowerCase() === String(optVal).trim().toLowerCase()) {
                p.classList.add('active');
              } else {
                p.classList.remove('active');
              }
            });
            const labelVal = group.querySelector('.gp-selected-option-value');
            if (labelVal) labelVal.textContent = cleanVariantTitle(optVal);
          }
        });
      }
      updateVariantUI(initialVariant);
    }
  }

  if (variantPills.length > 0) {
    variantPills.forEach(pill => {
      pill.addEventListener('click', (e) => {
        e.preventDefault();
        const optValue = pill.getAttribute('data-value');
        const cleanVal = cleanVariantTitle(pill.getAttribute('data-clean-value') || optValue);
        const group = pill.closest('.gp-option-group');

        if (group) {
          group.querySelectorAll('.gp-variant-pill').forEach(p => p.classList.remove('active'));
          pill.classList.add('active');

          const labelVal = group.querySelector('.gp-selected-option-value');
          if (labelVal) labelVal.textContent = cleanVal;
        }

        const matchedVariant = findMatchingVariant();
        updateVariantUI(matchedVariant);
      });
    });
  }

  // 12. Cash On Delivery Direct Button
  if (buyCodBtn) {
    buyCodBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const form = buyCodBtn.closest('form') || document.getElementById('gp-product-form');
      if (!form) return;

      let rawId = '';
      const idInput = form.querySelector('input[name="id"], select[name="id"]');
      if (idInput && idInput.value) rawId = idInput.value;
      if (!rawId) {
        const matched = typeof findMatchingVariant === 'function' ? findMatchingVariant() : null;
        if (matched && matched.id) rawId = String(matched.id);
      }
      if (!rawId) rawId = form.getAttribute('data-variant-id') || '';

      const qtyInput = form.querySelector('input[name="quantity"]');
      const rawQty = (qtyInput ? qtyInput.value : '1') || '1';
      const variantId = parseInt(rawId, 10);
      const quantity = Math.max(1, parseInt(rawQty, 10) || 1);

      if (!variantId || isNaN(variantId)) {
        alert('Please select an available product option.');
        return;
      }

      const origText = buyCodBtn.innerHTML;
      buyCodBtn.disabled = true;
      buyCodBtn.innerHTML = 'Processing Order...';

      const addUrl = getShopifyRoute('cart/add.js');
      const payload = {
        id: variantId,
        quantity: quantity
      };

      fetch(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      })
        .then(async (res) => {
          if (!res.ok) {
            const data = await res.json().catch(() => ({}));
            throw new Error((data && (data.description || data.message)) || 'Could not add product to cart');
          }
          return res.json();
        })
        .then(() => {
          if (isDesignMode()) {
            fetchAndRefreshCart(true);
            buyCodBtn.innerHTML = 'Added to Cart!';
            setTimeout(() => { buyCodBtn.innerHTML = origText; }, 2000);
            return;
          }
          window.location.href = '/checkout';
        })
        .catch(err => {
          console.error('COD error:', err);
          if (isDesignMode()) {
            fetchAndRefreshCart(true);
            buyCodBtn.innerHTML = 'Added to Cart!';
            setTimeout(() => { buyCodBtn.innerHTML = origText; }, 2000);
            return;
          }
          alert(err.message || 'Product is currently unavailable.');
          buyCodBtn.disabled = false;
          buyCodBtn.innerHTML = origText;
        })
        .finally(() => {
          if (isDesignMode()) {
            buyCodBtn.disabled = false;
            buyCodBtn.innerHTML = origText;
          }
        });
    });
  }
});